import { useEffect, useState } from "react";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import usePaginator from "../../../../../theme/Component/usePaginator";
import { Singleton } from "../../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../../theme/Component/BasicPage";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { BasicTable } from "../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { _OfficeRole } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { SelectRol } from "../../../../../admin/select/SelectRol";
import { _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { OfficeUse } from "./OfficeUser/OfficeUser";


interface Props {
    idOffice: number;
}

export const OfficeRole = ({ idOffice }: Props) => {

    const OfficeRole = useDataBean(_OfficeRole);
    const paginador = usePaginator();
    const [Role, setRole] = useState<any>(null)
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [form, setForm] = useState<any>({
        IDRole: null,
    })
    const [modaladd, setModaladd] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idOffice, paginador.page])

    const getLista = () => {

        OfficeRole.instance.getOfficeRoleCatalog(idOffice, Role, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)
                }
            }
        )

    }
    const create = () => {
        setModaladd({ ...modaladd, "view": true });
    }
    const deleteItem = () => {
        OfficeRole.instance.deleteOfficeRole(OfficeRole.bean.IDOfficeRole).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }

    const addOfficeRole = () => {
        OfficeRole.instance.addOfficeRole(idOffice, OfficeRole.bean.IDRole, _single.getAccountID()).then(
            (resp: any) => {
                getLista();
                setModaladd({ ...modaladd, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        OfficeRole.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDOfficeRole', visible: true },
        { title: 'Role', property: 'RoleName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (

        <div className="row">
            <div className="col-md-12">
                <label>Roles de la Oficina</label>
            </div>
            <div className="col-md-6">
                <SelectRol idSelector={Role} onChange={(e: any) => { setRole(e) }}></SelectRol>
            </div>
            <div className="col-md-6 mt-4 p-2">
                <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
            </div>
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={OfficeRole.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                <Modal modal={modaladd} updateModal={setModaladd} eventModal={addOfficeRole}>
                    <div className="row">
                        <div className="col-md-12">
                            <SelectRol idSelector={OfficeRole.bean.IDRole} onChange={(e: any) => { OfficeRole.setBean({ ...OfficeRole.bean, "IDRole": e }) }}></SelectRol>
                        </div>
                    </div>
                </Modal>
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item {OfficeRole.bean.Name}</strong>
                </ModalConfirm>
            </div>

        </div>

    )
}